import React from 'react';

import Inline from '@atlaskit/primitives/inline';
import { media } from '@atlaskit/primitives/responsive/media';
// eslint-disable-next-line @townsquare/rules/no-xcss
import { xcss } from '@atlaskit/primitives/xcss';

const styles = xcss({
	gridArea: 'actions',
	// eslint-disable-next-line @atlaskit/design-system/no-nested-styles
	[media.above.xxs]: {
		marginBlockStart: 'space.200',
	},
	// eslint-disable-next-line @atlaskit/design-system/no-nested-styles
	[media.above.sm]: {
		marginInlineStart: 'auto',
		marginBlockStart: 'unset',
	},
});

export const Actions = ({ children }: React.PropsWithChildren<unknown>): React.JSX.Element => {
	return (
		<Inline space="space.100" xcss={styles} shouldWrap>
			{children}
		</Inline>
	);
};
